import Theme from 'LegacyWeployDesignLanguage/Theme';

const styles = () => ({
  icon: {
    color: Theme.colors.iconColor,
    verticalAlign: 'middle',
    '&:hover': {
      color: Theme.colors.weployAqua,
    },
  },
});

export default styles;
